import { render, staticRenderFns } from "./LicitacaoEsclarecimentoImpugnacao.vue?vue&type=template&id=66e548d2&scoped=true"
import script from "./LicitacaoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./LicitacaoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=66e548d2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e548d2",
  null
  
)

export default component.exports